import { ProductTypeConfig, DEFAULT_SECTIONS } from '../types';

/**
 * Default - Para productos sin configuración específica
 */
export const defaultConfig: ProductTypeConfig = {
  code: 'default',
  name: 'Structured Product',
  sections: {
    ...DEFAULT_SECTIONS,
  },
};
